<template>
  <v-container pa-0 mt-5>
    <site-header :contact-details="contactDetails"/>
    <v-row align="center" justify="center" dense>
      <v-col cols="10"
             xl="6"
             lg="6"
             md="6"
             class="fill-height d-flex flex-column justify-center align-center">
        <v-card width="100%">
          <!--GetRsaId-->
          <template v-if="visibleCard == PageView.GetRsaId">
            <v-card-title>Identity Check</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field :disabled="isBusy"
                                label="RSA ID"
                                v-model="rsaId"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-select :disabled="isBusy"
                            :loading="isBusy"
                            :items="departments"
                            item-text="value"
                            item-value="key"
                            label="Department"
                            v-model="departmentId"
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <v-switch :disabled="isBusy"
                            v-model="agreeToCheck"
                            label="The above RSA ID belongs to me and Mafori may run a credit check on me."
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row align="end"
                     class="pt-0"
                     justify="end">
                <v-btn :disabled="!agreeToCheck || !(departmentId > 0) ||isBusy"
                       :loading="isBusy"
                       @click="GetRsaIdNext">
                  Next
                </v-btn>
              </v-row>
            </v-card-text>
          </template>
          <!--OtpNumberSelection-->
          <template v-if="visibleCard == PageView.OtpNumberSelection">
            <v-card-title>Contact Number</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-select :disabled="isBusy"
                            :items="contactNumbers"
                            label="Select contact number for OTP"
                            v-model="selectedContactNumber"/>
                </v-col>
              </v-row>
              <v-row align="end"
                     class="pt-0"
                     justify="end"
                     no-gutters>
                <v-btn :disabled="isBusy"
                       :loading="isBusy"
                       @click="OtpNumberSelectionNext">
                  Next
                </v-btn>
              </v-row>
            </v-card-text>
          </template>
          <!--ArrangeCall-->
          <template v-if="visibleCard == PageView.ArrangeCall">
            <v-card-title>Arrange Call</v-card-title>
            <v-card-subtitle>No contact numbers were found.<br/>Complete the
              below form to be contacted by a Mafori Advisory Agent
              agent.
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field :disabled="isBusy"
                                label="Name"
                                v-model="customName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field :disabled="isBusy"
                                label="Contact Number"
                                v-model="customContactNumber"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row align="end"
                     class="pt-0"
                     justify="end"
                     no-gutters>
                <v-btn :disabled="isBusy"
                       :loading="isBusy"
                       @click="ArrangeCallNext">
                  Submit
                </v-btn>
              </v-row>
            </v-card-text>
          </template>
          <!--EnterOtp-->
          <template v-if="visibleCard == PageView.EnterOtp">
            <v-card-title>Enter OTP</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field :disabled="isBusy"
                                label="OTP"
                                v-model="suppliedOtp"/>
                </v-col>
              </v-row>
              <v-row align="end"
                     class="pt-0"
                     justify="end"
                     no-gutters>
                <v-btn :disabled="isBusy"
                       :loading="isBusy"
                       @click="EnterOtpNext">
                  Next
                </v-btn>
              </v-row>
            </v-card-text>
          </template>
          <!--Submit-->
          <template v-if="visibleCard == PageView.Submit">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <person-score :rsa-id="rsaId"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <debt-restructuring-info :rsa-id="rsaId"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-btn color="primary">
                    Notices: {{ noticesCount }}
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn color="primary">
                    Judgements: {{ judgementsCount }}
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-switch :disabled="isBusy"
                            class="mb-0"
                            label="Loan"
                            v-model="loan"/>
                </v-col>
                <v-col cols="12">
                  <v-text-field :disabled="isBusy"
                                label="Loan Amount"
                                min="0"
                                type="number"
                                v-model.number="loanAmount"/>
                </v-col>
                <v-col cols="12">
                  <v-switch
                      :disabled="isBusy"
                      class="mb-0"
                      label="CreditRepair"
                      v-model="creditRepair"/>
                </v-col>
                <v-col cols="12">
                  <v-select
                      :disabled="isBusy"
                      :items="communicationOptions"
                      item-text="value"
                      item-value="key"
                      label="Preferred Communication"
                      v-model="communicationOption"/>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                      :disabled="isBusy"
                      accept="image/png, image/jpeg, image/bmp, application/pdf"
                      label="Payslips for last 3 Months"
                      placeholder="Select document"
                      ref="payslipDocumentInput"
                      v-model="payslipDocument"/>
                </v-col>

                <v-col cols="12">
                  <v-file-input
                      :disabled="isBusy"
                      accept="image/png, image/jpeg, image/bmp, application/pdf"
                      label="RSA ID"
                      placeholder="Select document"
                      ref="idDocumentInput"
                      v-model="idDocument"/>
                </v-col>

                <v-col cols="12">
                  <v-file-input
                      :disabled="isBusy"
                      accept="image/png, image/jpeg, image/bmp, application/pdf"
                      label="Proof Of Residence"
                      placeholder="Select document"
                      ref="proofOfResidenceDocumentInput"
                      v-model="proofOfResidenceDocument"/>
                </v-col>
              </v-row>

              <v-row align="end"
                     class="pt-0"
                     justify="end"
                     no-gutters>
                <v-btn :disabled="isBusy"
                       :loading="isBusy"
                       @click="Submit">
                  Submit
                </v-btn>
              </v-row>
            </v-card-text>
          </template>
          <!--Done-->
          <template v-if="visibleCard == PageView.Done">
            <v-card-title>Success!</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  A Mafori Advisory agent will be in contact with you shortly.
                  For any application related queries please send an email to <a
                    :href="queriesEmail">{{ this.contactDetails.queriesEmail }}</a>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
          <!--ArrangeCallDone-->
          <template v-if="visibleCard == PageView.ArrangeCallDone">
            <v-card-title>Success!</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  A Mafori Advisory agent will be in contact with you shortly.
                  For any application related queries please send an email to <a
                    :href="queriesEmail">{{ this.contactDetails.queriesEmail }}</a>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <site-footer :contact-details="contactDetails"/>
    <v-snackbar
        :color="notifyColor"
        :timeout="30000"
        top
        v-model="notifyShow"
    >
      {{ notifyMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
            @click="notifyShow = false"
            class="text-none"
            icon
            v-bind="attrs"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
//import dateToString from "../helpers/dateToString";
//import uuid4 from "../helpers/uuid4";
import PersonScore from "@/components/PersonScore/PersonScore.vue";
import DebtRestructuringInfo from "@/components/DebtRestructuring/DebtRestructuringInfo.vue";
import SiteHeader from "@/components/Header/SiteHeader.vue";
import SiteFooter from "@/components/Footer/SiteFooter.vue";

const PageView = {
  GetRsaId: "GetRsaId",
  OtpNumberSelection: "OtpNumberSelection",
  ArrangeCall: "ArrangeCall",
  EnterOtp: "EnterOtp,",
  Submit: "Submit",
  Done: "Done",
  ArrangeCallDone: "ArrangeCallDone",
};
export default {
  name: "Accounts",
  data: function () {
    return {
      contactDetails: {
        queriesEmail: null,
        supportEmail: null,
        whatsAppNumber: null,
      },
      departments: [],
      contactNumbers: [],
      communicationOptions: [],

      lookupId: 0,
      noticesCount: 0,
      judgementsCount: 0,

      isBusy: false,
      PageView,
      visibleCard: PageView.GetRsaId,

      notifyShow: null,
      notifyMessage: null,
      notifyColor: null,

      //GetRsaId
      agreeToCheck: false,
      departmentId: null,
      rsaId: "",

      //OtpNumberSelection
      selectedContactNumber: null,

      //ArrangeCall
      customName: "",
      customContactNumber: "",

      //EnterOtp
      suppliedOtp: "",

      //Submit
      loan: false,
      loanAmount: 0,
      creditRepair: false,
      communicationOption: null,
      payslipDocument: null,
      idDocument: null,
      proofOfResidenceDocument: null,

      //Done
      credisolveCaseNumber: "",
    };
  },
  mounted: async function () {
    this.isBusy = true;
    this.departments = await this.$store.dispatch(
        "experian/getDepartments"
    );
    this.isBusy = false;
    this.communicationOptions = await this.$store.dispatch(
        "experian/getCommunicationOptions"
    );
    this.getContactDetails();
  },
  components: {
    SiteFooter,
    SiteHeader,
    PersonScore,
    DebtRestructuringInfo
    //
  },
  methods: {
    validRsaId(v) {
      var invalidId = false;
      if (!v || v.length != 13) return invalidId;

      var idNumbers;
      try {
        idNumbers = v.split("").map((x) => parseInt(x));
      } catch {
        return invalidId;
      }

      if (idNumbers[10] > 1) return invalidId;

      var evens = [
        idNumbers[1],
        idNumbers[3],
        idNumbers[5],
        idNumbers[7],
        idNumbers[9],
        idNumbers[11],
      ];

      var odds = [
        idNumbers[0],
        idNumbers[2],
        idNumbers[4],
        idNumbers[6],
        idNumbers[8],
        idNumbers[10],
        idNumbers[12],
      ];

      var evensLuhnSum = evens
          .map((x) => {
            var d = 2 * x;
            if (d > 9) {
              var dstring = d.toString();
              d = parseInt(dstring[0]) + parseInt(dstring[1]);
            }
            return d;
          })
          .reduce((a, b) => a + b, 0);

      var oddsSum = odds.reduce((a, b) => a + b, 0);

      return (evensLuhnSum + oddsSum) % 10 == 0;
    },
    notify(message, color) {
      this.notifyShow = true;
      this.notifyMessage = message;
      this.notifyColor = color;
    },

    GetRsaIdNext() {
      if (this.validRsaId(this.rsaId)) {
        this.isBusy = true;
        this.$store
            .dispatch("experian/getContactNumbers", {
              rsaId: this.rsaId,
            })
            .then(
                (result) => {
                  this.lookupId = result.lookupId;
                  this.contactNumbers = result.contactNumbers;
                  this.noticesCount = result.noticesCount;
                  this.judgementsCount = result.judgementsCount;
                  if (
                      !this.contactNumbers ||
                      this.contactNumbers.length == 0
                  ) {
                    this.visibleCard = PageView.ArrangeCall;
                  } else {
                    this.visibleCard = PageView.OtpNumberSelection;
                  }
                },
                (error) => this.notify(error.response.data, "error")
            )
            .finally(this.GetRsaIdNextDone);
      } else this.notify("Invalid RSA ID", "orange");
    },
    GetRsaIdNextDone() {
      this.isBusy = false;
    },

    OtpNumberSelectionNext() {
      if (this.selectedContactNumber) {
        this.isBusy = true;
        this.$store
            .dispatch("experian/submitContactNumber", {
              contactNumber: this.selectedContactNumber,
            })
            .then(
                () => {
                  this.visibleCard = PageView.EnterOtp;
                },
                (error) => this.notify(error.response.data, "error")
            )
            .finally(this.OtpNumberSelectionNextDone);
      } else this.notify("Select a contact number.", "orange");
    },
    OtpNumberSelectionNextDone() {
      this.isBusy = false;
    },

    EnterOtpNext() {
      if (this.suppliedOtp) {
        this.isBusy = true;
        this.$store
            .dispatch("experian/confirmOtp", {
              contactNumber: this.selectedContactNumber,
              otp: this.suppliedOtp,
            })
            .then(
                (confirmed) => {
                  if (confirmed) this.visibleCard = PageView.Submit;
                  else this.notify("Incorrect OTP.", "orange");
                },
                (error) => this.notify(error.response.data, "error")
            )
            .finally(this.OtpNumberSelectionNextDone);
      } else this.notify("Enter OTP.", "orange");
    },
    EnterOtpNextDone() {
      this.isBusy = false;
    },

    Submit() {
      if (
          !!this.payslipDocument &&
          !!this.idDocument &&
          !!this.proofOfResidenceDocument &&
          ((this.loan && this.loanAmount > 0) || this.creditRepair) &&
          this.communicationOption > 0
      ) {
        this.isBusy = true;

        var formdata = new FormData();

        formdata.append("PayslipDocument", this.payslipDocument);
        formdata.append("IdDocument", this.idDocument);
        formdata.append(
            "ProofOfResidenceDocument",
            this.proofOfResidenceDocument
        );
        formdata.append(
            "Model",
            JSON.stringify({
              loan: this.loan,
              loanAmount: this.loanAmount > 0 ? this.loanAmount : 0,
              creditRepair: this.creditRepair,
              communicationOption: this.communicationOption,
              departmentId: this.departmentId,
              lookupId: this.lookupId,
              contactNumber: this.selectedContactNumber
            })
        );

        this.$store
            .dispatch("experian/credisolveSubmit", formdata)
            .then(
                () => {
                  this.visibleCard = PageView.Done;
                },
                (error) => this.notify(error.response.data, "error")
            )
            .finally(this.SubmitDone);
      } else
        this.notify(
            "Complete the form, Loan and/or Credir Repair required.",
            "orange"
        );
    },
    SubmitDone() {
      this.isBusy = false;
    },

    ArrangeCallNext() {
      if (this.customName && this.customContactNumber) {
        this.isBusy = true;
        this.$store
            .dispatch("experian/arrangeCallSubmit", {
              name: this.customName,
              contactNumber: this.customContactNumber,
              departmentId: this.departmentId,
            })
            .then(
                () => {
                  this.visibleCard = PageView.ArrangeCallDone;
                },
                (error) => this.notify(error.response.data, "error")
            )
            .finally(this.OtpNumberSelectionNextDone);
      } else this.notify("Complete Form.", "orange");
    },
    ArrangeCallNextDone() {
      this.isBusy = false;
    },
    getContactDetails() {
      this.$store
          .dispatch("experian/getContactDetails")
          .then(
              (result) => {
                this.contactDetails = result;
                console.log(result);
              },
              (error) => this.notify(error.response.data, "error")
          );
    },
  },
  computed: {
    supportEmail() {
      return 'mailto:' + this.contactDetails.supportEmail;
    },
    queriesEmail() {
      return 'mailto:' + this.contactDetails.queriesEmail;
    },
    whatsapp() {
      return `https://api.whatsapp.com/send?phone=${this.contactDetails.whatsAppNumber}&text=Hi%2C%20I%20would%20like%20assistance.`;
    }
  }
};
</script>

<style lang="stylus" scoped></style>
